/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { Currency } from '@api/model';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { Router, } from 'react-router-dom';
import { defaultAxios } from '../../api/services/DefaultHttpClient';
import history from '../../constant/History';
import { DefaultThemeKey } from '../../models/Theme';
import { getCollegeKey, setCurrency } from '../../redux/actions/College';
import { getSites } from '../../redux/actions/Sites';
import { getPublicProperties, getSystemProperties } from '../../redux/actions/SystemProperties';
import { useAppDispatch, useAppSelector } from '../../redux/hooks/redux';
import { getTheme } from '../../themes/ishTheme';
import { ThemeContext } from '../../themes/ThemeContext';
import ConfirmProvider from '../common/dialog/ConfirmProvider';
import MessageProvider from '../common/message/MessageProvider';
import Settings from '../settings/Settings';
import Stepper from '../stepper/Stepper';

export const muiCache = createCache({
  key: 'mui',
  prepend: true,
});

const Main = () => {
  const [themeName, setThemeName] = useState(DefaultThemeKey);
  const [theme, setTheme] = useState(getTheme());

  const isNewUser = useAppSelector((state) => state.college.isNewUser);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const token = query.get('token');
    const currency = query.get('currency') as Currency;
    if (currency) {
      dispatch(setCurrency(currency));
    }
    if (token) {
      defaultAxios.defaults.headers.common = {
        Authorization: token
      };
    }
    window.history.replaceState(null, null, window.location.pathname);
    dispatch(getCollegeKey());
    dispatch(getPublicProperties());
  }, []);

  useEffect(() => {
    if (!isNewUser) {
      dispatch(getSystemProperties());
      dispatch(getSites());
    }
  }, [isNewUser]);

  const themeHandler = (name: any) => {
    setThemeName(name);
    setTheme(getTheme());
    localStorage.setItem('theme', name);
  };

  return (
      <CacheProvider value={muiCache}>
        <ThemeContext.Provider
          value={{
            themeHandler,
            themeName
          }}
        >
          <ThemeProvider theme={theme}>
            <Router history={history}>
              {isNewUser ? <Stepper /> : <Settings />}
            </Router>
            <MessageProvider />
            <ConfirmProvider />
          </ThemeProvider>
        </ThemeContext.Provider>
      </CacheProvider>
  );
};

export default Main;
